import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaDocumentos: [],
  listaAlugueis: [],
  listaVendas: [],
  listaAssinaturas: [],
  listaClientes: [],
  listaImoveisAluguel: [],
  listaImoveis: [],
  listaImoveisVenda: [],
  listaEnvolvidos: [],
  listaVistorias: []
}

const mutations = {
  atualizarListaDocumentos(state, lista) {
    state.listaDocumentos = lista;
  },

  atualizarListaAlugueis(state, lista) {
    state.listaAlugueis = lista;
  },

  atualizarListaVendas(state, lista) {
    state.listaVendas = lista;
  },

  atualizarListaAssinaturas(state, lista) {
    state.listaAssinaturas = lista;
  },

  atualizarListaClientes(state, lista) {
    state.listaClientes = lista;
  },

  atualizarListaImoveisAluguel(state, lista) {
    state.listaImoveisAluguel = lista;
  },

  atualizarListaImoveis(state, lista) {
    state.listaImoveis = lista;
  },

  atualizarListaImoveisVenda(state, lista) {
    state.listaImoveisVenda = lista;
  },

  atualizarListaEnvolvidos(state, lista) {
    state.listaEnvolvidos = lista;
  },

  atualizarListaVistorias(state, payload) {
    state.listaVistorias = payload;
  },
 
  limparListas(state) {
    state.listaDocumentos = [],
    state.listaAlugueis = [],
    state.listaVendas = [],
    state.listaVistorias = []
  }
}

const actions = {
  limparListas(context) {
    context.commit('limparListas');
  },

  listarDocumentos(context, payload) {
    return axios.post(URLS.CLICK_SIGN_LISTAR_DOCUMENTOS, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaDocumentos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarDocumentos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarAssinaturas(context, payload) {
    return axios.post(URLS.CLICK_SIGN_LISTAR_ASSINATURAS, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarListaAssinaturas', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarAssinaturas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaAlugueis', response.data.lista)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarAlugueis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarVendas(context, payload) {
    return axios.post(URLS.VENDAS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaVendas', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarVendas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarListaClientes', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarClientes', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  criarAssinatura(context, payload) {
    return axios.post(URLS.CLICK_SIGN_CRIAR_ASSINATURA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarAssinatura', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  gravarSignatarios(context, payload) {
    return axios.post(URLS.CLICK_SIGN_GRAVAR_SIGNATARIOS, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gravarSignatarios', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  solicitarAssinaturas(context, payload) {
    return axios.post(URLS.CLICK_SIGN_SOLICITAR_ASSINATURAS, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('solicitarAssinaturas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(payload.operacao === 'ALUGUEL') {
            context.commit('atualizarListaImoveisAluguel', response.data.lista);
          } else {
            context.commit('atualizarListaImoveis', response.data.lista);
          }

          return response.data; 
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarImoveis', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarImoveisVenda(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(payload.operacao === 'VENDA') {
            context.commit('atualizarListaImoveisVenda', response.data.lista);
          }

          return response.data; 
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarImoveisVenda', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarEnvolvidosAluguel(context, payload) {
    return axios.post(URLS.ZAP_SIGN_LISTAR_ENVOLVIDOS_ALUGUEL, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(response.data.item) {
            context.commit('atualizarListaEnvolvidos', response.data.item.signatarios)
          } else {
            context.commit('atualizarListaEnvolvidos', [])
          }
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarEnvolvidosAluguel', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarEnvolvidosVenda(context, payload) {
    return axios.post(URLS.ZAP_SIGN_LISTAR_ENVOLVIDOS_VENDA, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(response.data.item) {
            context.commit('atualizarListaEnvolvidos', response.data.item.signatarios)
          } else {
            context.commit('atualizarListaEnvolvidos', [])
          }
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarEnvolvidosVenda', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarEnvolvidosImovel(context, payload) {
    return axios.post(URLS.ZAP_SIGN_LISTAR_ENVOLVIDOS_IMOVEL, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(response.data.item) {
            context.commit('atualizarListaEnvolvidos', response.data.item.signatarios)
          } else {
            context.commit('atualizarListaEnvolvidos', [])
          }
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarEnvolvidosImovel', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },


  listarEnvolvidosVistoria(context, payload) {
    return axios.post(URLS.ZAP_SIGN_LISTAR_ENVOLVIDOS_VISTORIA, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          if(response.data.item) {
            context.commit('atualizarListaEnvolvidos', response.data.item.signatarios)
          } else {
            context.commit('atualizarListaEnvolvidos', [])
          }
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarEnvolvidosVistoria', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  

  listarVistorias(context, payload) {
    return axios.post(URLS.VISTORIAS_LISTAR, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarListaVistorias', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarVistorias', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },
}

export default {
  state,
  mutations,
  actions
}